
/*
 *
 * Results Actions
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 12-Feb-2025
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index'

export const actionTypes = {
  DO_GET_GROUP_BY_COUNTRY: '@@Results/get_group_by_country',
  DO_GET_GROUP_BY_CARD_BRAND: '@@Results/get_group_by_card_brand',
  DO_GET_TOTAL_CLIENTS: '@@Results/get_total_clients',
  DO_GET_TOTAL_CLIENTS_DETAILS: '@@Results/get_total_clients_details',
  DO_GET_GROUP_BY_COST: '@@Results/get_group_by_cost',
  DO_GET_PEER_COMPARISON_DATA: '@@Results/get_peer_comparison_data',
  DO_RESULT_TAB_SELECTED: '@@Results/get_result_tab_selected',
  DO_GET_RESULTS_CATEGORIES: '@@Results/get_results_categories',
  DO_SET_REFERRED_PERIOD: '@@Results/get_set_referred_period',
  DO_GET_BEST_PERFORMANCE: '@@Results/get_best_performance',
  DO_GET_SHOP_LIST: '@@Results/get_shop_list',
  DO_GET_SHOP_DETAILS: '@@Results/get_shop_details',
  DO_GET_PERFORMANCE_CHART: '@@Results/get_performance_chart',
  DO_HANDLE_SHOW_RESULTS_SECTOR_FILTER: '@@Results/handle_show_results_sector_filter',
  DO_SET_LAST_APPLIED_PARAMS: '@@Results/set_last_applied_params',
  // @generator action:route:type
  ...createRequestTypes('@@Results', 'GET_GROUP_BY_COST'),
  ...createRequestTypes('@@Results', 'GET_GROUP_BY_CARD_BRAND'),
  ...createRequestTypes('@@Results', 'GET_TOTAL_CLIENTS'),
  ...createRequestTypes('@@Results', 'GET_TOTAL_CLIENTS_DETAILS'),
  ...createRequestTypes('@@Results', 'GET_GROUP_BY_COUNTRY'),
  ...createRequestTypes('@@Results', 'GET_PEER_COMPARISON_DATA'),
  ...createRequestTypes('@@Results', 'GET_RESULTS_CATEGORIES'),
  ...createRequestTypes('@@Results', 'GET_BEST_PERFORMANCE'),
  ...createRequestTypes('@@Results', 'GET_SHOP_LIST'),
  ...createRequestTypes('@@Results', 'GET_SHOP_DETAILS'),
  ...createRequestTypes('@@Results', 'GET_PERFORMANCE_CHART')
  // @generator action:route:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:route:request
/** @action request
* * Insert a description
* @name getPerformanceChart
* @return {object} - The action object
*/
export const getPerformanceChart = new MakeRequest('Results', 'get_performance_chart')
/** @action request
* * Insert a description
* @name getShopDetails
* @return {object} - The action object
*/
export const getShopDetails = new MakeRequest('Results', 'get_shop_details')
/** @action request
* * Insert a description
* @name getShopList
* @return {object} - The action object
*/
export const getShopList = new MakeRequest('Results', 'get_shop_list')
/** @action request
* * Insert a description
* @name getBestPerformance
* @return {object} - The action object
*/
export const getBestPerformance = new MakeRequest('Results', 'get_best_performance')
/** @action request
* * Insert a description
* @name getResultsCategories
* @return {object} - The action object
*/
export const getResultsCategories = new MakeRequest('Results', 'get_results_categories')
/** @action request
* * Insert a description
* @name getPeerComparisonData
* @return {object} - The action object
*/
export const getPeerComparisonData = new MakeRequest('Results', 'get_peer_comparison_data')
/** @action request
* * Insert a description
* @name getGroupByCountry
* @return {object} - The action object
*/
export const getGroupByCountry = new MakeRequest('Results', 'get_group_by_country')
/** @action request
* * Insert a description
* @name getTotalClients
* @return {object} - The action object
*/
export const getTotalClients = new MakeRequest('Results', 'get_total_clients')
/** @action request
* * Insert a description
* @name getTotalClientsDetails
* @return {object} - The action object
*/
export const getTotalClientsDetails = new MakeRequest('Results', 'get_total_clients_details')
/** @action request
* * Insert a description
* @name getGroupByCardBrand
* @return {object} - The action object
*/
export const getGroupByCardBrand = new MakeRequest('Results', 'get_group_by_card_brand')
/** @action request
* * Insert a description
* @name getGroupByCost
* @return {object} - The action object
*/
export const getGroupByCost = new MakeRequest('Results', 'get_group_by_cost')
// @generator action:route
/** @action
* * Insert a description
* @name GetPerformanceChart
* @return {object} - The payload object
*/
export const doGetPerformanceChart = payload => createAction(actionTypes.DO_GET_PERFORMANCE_CHART, { payload })
/** @action
* * Insert a description
* @name GetShopDetails
* @return {object} - The payload object
*/
export const doGetShopDetails = shopId => createAction(actionTypes.DO_GET_SHOP_DETAILS, { shopId })
/** @action
* * Insert a description
* @name GetShopList
* @return {object} - The payload object
*/
export const doGetShopList = payload => createAction(actionTypes.DO_GET_SHOP_LIST, { payload })
/** @action
* * Insert a description
* @name GetBestPerformance
* @return {object} - The payload object
*/
export const doGetBestPerformance = payload => createAction(actionTypes.DO_GET_BEST_PERFORMANCE, { payload })
/** @action
* * Insert a description
* @name GetResultsCategories
* @return {object} - The payload object
*/
export const doGetResultsCategories = payload => createAction(actionTypes.DO_GET_RESULTS_CATEGORIES, { payload })
/** @action
* * Insert a description
* @name GetPeerComparisonData
* @return {object} - The payload object
*/
export const doGetPeerComparisonData = payload => createAction(actionTypes.DO_GET_PEER_COMPARISON_DATA, { payload })
/** @action
* * Insert a description
* @name GetGroupByCost
* @return {object} - The payload object
*/
export const doGetGroupByCost = payload => createAction(actionTypes.DO_GET_GROUP_BY_COST, { payload })
/** @action
* * Insert a description
* @name GetGroupByCountry
* @return {object} - The payload object
*/
export const doGetGroupByCountry = payload => createAction(actionTypes.DO_GET_GROUP_BY_COUNTRY, { payload })
/** @action
* * Insert a description
* @name GetTotalClients
* @return {object} - The payload object
*/
export const doGetTotalClients = payload => createAction(actionTypes.DO_GET_TOTAL_CLIENTS, { payload })
/** @action
* * Insert a description
* @name GetTotalClientsDetails
* @return {object} - The payload object
*/
export const doGetTotalClientsDetails = payload => createAction(actionTypes.DO_GET_TOTAL_CLIENTS_DETAILS, { payload })
/** @action
* * Insert a description
* @name GetGroupByCardBrand
* @return {object} - The payload object
*/
export const doGetGroupByCardBrand = payload => createAction(actionTypes.DO_GET_GROUP_BY_CARD_BRAND, { payload })

/** @action
* * Action to handle the result tab current selected
* @name ResultTabSelected
* @return {object} - The payload object
*/
export const doResultTabSelected = payload => createAction(actionTypes.DO_RESULT_TAB_SELECTED, { payload })

/** @action
* * Action to handle the period selected in result page
* @name SetReferredPeriod
* @return {object} - The payload object
*/
export const doSetReferredPeriod = payload => createAction(actionTypes.DO_SET_REFERRED_PERIOD, { payload })

/** @action
* * Action to handle the results sector filter visibility
* @name HandleShowResultsSectorFilter
* @return {object} - The payload object
*/
export const doHandleShowResultsSectorFilter = payload => createAction(actionTypes.DO_HANDLE_SHOW_RESULTS_SECTOR_FILTER, { payload })

/** @action
* * Action to save last applied params for lazy loading details
* @name SetLastAppliedParams
* @return {object} - The payload object
*/
export const doSetLastAppliedParams = payload => createAction(actionTypes.DO_SET_LAST_APPLIED_PARAMS, { payload })
